import React from 'react';
import Popup from 'reactjs-popup';
import { SubtitleContext } from '../../contexts/SubtitleContext';
import Versions from '../translations/versions/Versions';
import ApiUtils from '../../helper/ApiUtils';
import StringUtils from '../../helper/StringUtils';
import TimeUtils from '../../helper/TimeUtils';
import { confirmAlert } from 'react-confirm-alert';

const VersionsView_Popup = ({ _WaveformView }) => {
  return (
    <Popup
      open={_WaveformView.state.isShowVersionsView}
      modal
      closeOnDocumentClick
      onClose={() => {
        _WaveformView.setState({ isShowVersionsView: false });
      }}
      contentStyle={{ width: '750px' }}
    >
      <SubtitleContext.Consumer>
        {(context) => (
          <Versions
            context={context}
            onClose={() => {
              _WaveformView.setState({ isShowVersionsView: false });
            }}
            findFrameSplitValue={_WaveformView.findFrameSplitValue}
            videoFps={TimeUtils.getFPS()}
            loadFile={async (fId) => {
              confirmAlert({
                title: 'WARNING',
                message: `Load version ${fId} ?`,
                buttons: [
                  {
                    label: 'Ok',
                    onClick: async () => {
                      //計時歸0
                      _WaveformView.countSeconds = 0;

                      await _WaveformView.setState({ loading: true });

                      let jsonDataString = await ApiUtils.post_sql(
                        `${ApiUtils.get_DetialJsonDataString}`,
                        {
                          fId: fId,
                        }
                      );
                      jsonDataString =
                        StringUtils.UnZipUploadFile(jsonDataString);

                      //初始字幕跟拖拉資料
                      _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                        jsonDataString
                      );

                      _WaveformView.setIsEdit(true);

                      await _WaveformView.setState({ loading: false });
                      await _WaveformView.setState({
                        isShowVersionsView: false,
                      });
                    },
                  },
                  {
                    label: 'Cancel',
                  },
                ],
              });
            }}
          />
        )}
      </SubtitleContext.Consumer>
    </Popup>
  );
};

export default VersionsView_Popup;



// WEBPACK FOOTER //
// ./src/components/popup/VersionsView_Popup.js